export const CVAPI = process.env.REACT_APP_CV_API;
export const USERAPI = process.env.REACT_APP_USER_API;
export const CONCURSOAPI = process.env.REACT_APP_CONCURSO_API;
export const PONDERACIONAPI = process.env.REACT_APP_PONDERACION_API;
export const ACTASAPI = process.env.REACT_APP_ACTAS_API;
export const EVALUACIONAPI = process.env.REACT_APP_EVALUACION_API;
export const AUTENTICARURLAFIP = process.env.REACT_APP_AUTENTICAR_URL_AFIP;
export const AUTENTICARLOGOUTURLAFIP = process.env.REACT_APP_AUTENTICAR_LOGOUT_URL_AFIP;
export const AUTENTICARURLMIARGENTINA = process.env.REACT_APP_AUTENTICAR_URL_MIARGENTINA;
export const AUTENTICARLOGOUTURLMIARGENTINA =
  process.env.REACT_APP_AUTENTICAR_LOGOUT_URL_MIARGENTINA;
export const THISISNOTAS3CR3T = process.env.REACT_APP_THIS_IS_NOT_A_S3CR3T;
export const THISISAS3CR3T = process.env.REACT_APP_THIS_IS_A_S3CR3T;

export const ROLES = {
  GUEST: 'ROLE_GUEST', //Invitado, no logueado
  USER: 'ROLE_USER',
  ADMIN: 'ROLE_ADMIN',
  COMITE: 'ROLE_COMITE',
  DIRECTOR: 'ROLE_DIRECTOR',
  LEGALES: 'ROLE_LEGALES',
};
export const ROLES_COMITE_ID = {
  INTERNO: 1, //Invitado, no logueado
  EXTERNO: 2,
  ORGANO_RECTOR: 3,
  ASESOR_TEMATICO: 4,
  CC: 5,
  VEEDOR: 6,
};

// ESTADOS_CONVOCATORIA hace referencia al id_etapa_llamado_concurso
export const ESTADOS_CONVOCATORIA = {
  CARGA_EXPEDIENTE: 1,
  ASIGNACION_CC: 2,
  ASIGNACION_VEEDORES: 3,
  CARGA_DICTAMEN: 4,
  PRIMER_ACTA: 5,
  ACTO_ADMINISTRATIVO: 6,
  PUBLICACION_CONVOCATORIA: 7,
  CONVOCATORIA_PUBLICADA: 8,
  INSCRIPCION_WEB: 9,
  EVALUACION_INICIAL: 10,
  VALIDACION_DOCUMENTAL: 11,
  AMPLIACION_DOCUMENTAL: 19,
  VALIDACION_POS_PERIODO_AMPLIACION_DOCUMENTAL: 20,
  EVALUACION_ANTECEDENTES: 12,
  EVALUACION_TECNICA_GENERAL: 13,
  EVALUACION_TECNICA_SUSTANTIVA: 14,
  EVALUACION_LABORAL: 15,
  EVALUACION_PSICOLOGICA: 16,
  ORDEN_DE_MERITO: 17,
  CONCURSO_FINALIZADO: 18, // 20
};

//Según la BD
// export const ETAPAS = {
//   VACANTE_ASIGNADA: 1,
//   CONVOCATORIA_ASIGNADA: 2,
//   CC_ASIGNADO: 3,
//   VEEDORES_ASIGNADOS: 4,
//   POCO_CLARA: 5,
//   PUESTOS_IMPORTADOS: 6,
//   DOC_CONCURSOS: 7,
//   ACTA_CREADA: 8,
//   BORA_IMPORTADO: 9,
//   VEEDORES_INFORMADOS: 10,
//   PUBLICADA: 11,
// }

//Según la documentación
// export const ETAPAS = {
//   CARGA_CONVOCATORIA: 1,
//   DESIGNACION_CC: 2,
//   DESIGNACION_VEEDORES: 3,
//   CARGA_DICTAMEN: 4,
//   PRIMER_ACTA: 5,
//   CARGA_ACTO_ADM: 6,
//   PUBLICACION: 7,
//   ACTA_CREADA: 8,
//   BORA_IMPORTADO: 9,
//   VEEDORES_INFORMADOS: 10,
//   PUBLICADA: 11,
// };

const dateFormat = require('dateformat');
dateFormat.i18n = {
  dayNames: [
    'Dom',
    'Lun',
    'Mar',
    'Mie',
    'Jue',
    'Vie',
    'Sab',
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ],
  monthNames: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  timeNames: ['a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'],
};

export const GREMIOS = {
  ATE: 'ATE',
  UPCN: 'UPCN',
  MINMUJ: 'Ministerio de la Mujer',
  MINTRA: 'Ministerio de Trabajo',
};
